import Service from "./Service";
import GeneralUtils from "../utils/GeneralUtils";
import {SERVER_URL} from "../utils/Constants";


export default class FileService extends Service {
    constructor() {
        super();
        this.baseURL = 'file';
    }

    upload(data) {
        return fetch(SERVER_URL + this.baseURL + "/upload", {
            crossDomain: true,
            method: 'POST',
            headers: {Authorization: localStorage.getItem("Authorization")},
            body: data
        }).then(response => {
            let result = response.clone();
            GeneralUtils.notification(response);
            return result.json();
        }).catch(error => {
            GeneralUtils.notification(error);
        });
    }

    getFileByName(name) {
        return fetch(SERVER_URL + this.baseURL + '/getFileByName/' + name, {
            headers: {'Content-Type': 'image/jpeg', Authorization: localStorage.getItem("Authorization")}
        })
            .then(response => response.blob())
            // .then(images => {
            //     // Then create a local URL for that image and print it
            //     let imgUrl = URL.createObjectURL(images);
            //     return imgUrl;
            // })
            .catch(error => {
                GeneralUtils.notification(error);
            });
    }
}
